// Builds a query string fragment (without leading "?") for a list of compound ids, e.g.
// "compoundIds=a&compoundIds=b". Axios' default array serialization uses "key[]=" which the
// backend's [FromQuery] string[] binder does not understand, so we build the repeated-key
// format expected by ASP.NET Core manually.
export default (compoundIds: string[]) =>
	compoundIds.map((id) => `compoundIds=${encodeURIComponent(id)}`).join("&");
